import { combineReducers } from 'redux';
import league from './mpp/league';
import activeLeagues from './mpp/activeLeagues';
import userStats from './mpp/userStats';

export default combineReducers({
    league,
    activeLeagues,
    userStats,
});



// WEBPACK FOOTER //
// ./src/reducers/app/other/mpp.js